<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="编辑原因"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-form
        inline
        ref="form"
        class="search-form"
        label-position="right"
        :model="form"
        :rules="rules"
        label-width="70px"
      >
        <el-form-item label="故障原因：" prop="faultReason" class="input-with-col2 mr0">
          <el-input size="mini" v-model.trim="form.faultReason" placeholder="请输入故障原因" clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="plr28" size="mini" type="info" plain @click="handleCancel">取消</el-button>
      <el-button
        class="plr28"
        type="primary"
        size="mini"
        :loading="loadBtn"
        @click="handleConfirm"
      >确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveFaultReason } from "@/api/FaultCause";
export default {
  data() {
    return {
      form: {
        faultReason: ''
      },
      rules: {
        faultReason: [
          {
            required: true,
            message: "请输入故障原因",
            trigger: "blur",
          },
        ],
      },
      loadBtn: false,
    };
  },
  props: {
    editData: {
      type: Object,
      required: true
    }
  },
  created() {
    this.form = { ...this.editData }
  },
  methods: {
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      if (this.loadBtn) return;
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          this.loadBtn = true;
          const res = await saveFaultReason(this.form);
          if (res.code === 200) {
            this.$message.success("编辑成功");
            this.$emit("confirm");
          }
          this.loadBtn = false;
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/FaultCause/components/EditCause.vue